import ResetPasswordFormComponent from './reset-password-form-component';

export type IProps = {
  isLoading: boolean;
  buttonText: string;
  onSubmit: (email: string, captchaToken: string) => void;
};

export default ResetPasswordFormComponent;
